<section class="rs-content-wrapper rs-header-has-level2" id="cybercareDetails">
  <main id="maincontent" role="main">
    <section class="rs-es-first-section">
      <mprd-back-link></mprd-back-link>
      <div class="row">
        <div class="columns small-12">
          <h1 class="rs-tit1-sp rs-txt-c2 rs-has-subtit" data-cy="cybercareTitle">{{ title }}</h1>
          <p class="rs-txt-s5 rs-txt-c2" x-ms-format-detection="none" data-cy="cybercareServiceId">
            {{ serviceId }}
          </p>
          <div class="rs-panel-big rs-bg-c2 clearfix">
            <h2 class="rs-tit3 rs-has-subtit" data-cy="cybercareSubtitle1">
              {{ 'cybercare.subtitle1' | translate }}
            </h2>
            <h3 class="rs-subtit" data-cy="cybercareSubtitle2">
              {{ 'cybercare.subtitle2' | translate }}
            </h3>
            <p
              data-cy="cybercareDescription"
              [innerHTML]="'cybercare.description' | translate: true"
            ></p>
            <p>
              <mprd-price
                *ngIf="fakeCyberCareOption !== undefined"
                [option]="fakeCyberCareOption"
                [showActiveStatus]="false"
                amountClass="rs-price-m"
              ></mprd-price>
            </p>
            <p>
              <mprd-cyber-care-yearly-price
                *ngIf="fakeCyberCareOption !== undefined"
                [yearlyPrice]="yearlyPrice"
              >
              </mprd-cyber-care-yearly-price>
            </p>
            <p>
              <button
                class="rs-btn"
                aria-haspopup="true"
                (click)="showCeasePopup()"
                data-tms-event="button-click"
                data-tms-button-name="cease"
                data-tms-action-name="addcease"
                attr.data-tms-product="{{ jsonProduct }}"
                data-cy="cybercareCeaseButton"
              >
                {{ 'cybercare.cease' | translate }}
              </button>
            </p>

            <h2 class="rs-tit3 rs-has-subtit">{{ 'cybercare.coverage.title' | translate }}</h2>

            <mprd-cyber-care-coverage></mprd-cyber-care-coverage>

            <mprd-cyber-care-claim></mprd-cyber-care-claim>
          </div>
          <div class="rs-le2"></div>
        </div>
      </div>
    </section>
  </main>
</section>
